// sharePrefs.js
//
// Preferências da tela de compartilhar, por APARELHO (localStorage). São dois
// interruptores que o usuário liga e desliga quando quiser:
//
//   ORDEM_ALEATORIA (padrão LIGADO)  embaralha a ordem das artes a cada
//     abertura da tela — sem isso a primeira arte é sempre a mesma e o feed de
//     quem posta todo dia fica repetitivo.
//   TRANSPARENTE (padrão DESLIGADO)  esconde a foto de fundo e os degradês; as
//     artes saem com fundo 100% transparente (PNG com alfa), mantendo as infos.
//   OCULTAR_PONTAS (padrão LIGADO)  só vale para atividade GPS: corta 200 m de
//     cada ponta do traçado desenhado na arte (onde começa e termina costuma
//     ser onde a pessoa mora). Ver features/atividade/arteGps.js.
//
// Por que localStorage e não Firestore: é preferência de exibição, muda com um
// toque e não vale uma escrita no banco por clique. Storage indisponível (aba
// privada, WebView restrita) NUNCA pode derrubar a tela — daí o try/catch em
// tudo e o default explícito.

const CHAVE = 'lesvita.share.prefs.v1';

export const PADRAO = Object.freeze({
  ordemAleatoria: true,
  transparente: false,
  /* Story é o padrão: é o formato das 17 artes calibradas e o destino mais
     comum. O feed (4:5) é escolha explícita de quem quer postar na grade. */
  formatoFeed: false,
  ocultarPontas: true,
});

export function lerPrefs() {
  try {
    const bruto = JSON.parse(localStorage.getItem(CHAVE) || 'null');
    if (!bruto || typeof bruto !== 'object') return { ...PADRAO };
    return {
      ordemAleatoria: typeof bruto.ordemAleatoria === 'boolean'
        ? bruto.ordemAleatoria : PADRAO.ordemAleatoria,
      transparente: typeof bruto.transparente === 'boolean'
        ? bruto.transparente : PADRAO.transparente,
      formatoFeed: typeof bruto.formatoFeed === 'boolean'
        ? bruto.formatoFeed : PADRAO.formatoFeed,
      ocultarPontas: typeof bruto.ocultarPontas === 'boolean'
        ? bruto.ocultarPontas : PADRAO.ocultarPontas,
    };
  } catch {
    return { ...PADRAO };
  }
}

export function salvarPrefs(prefs) {
  try {
    localStorage.setItem(CHAVE, JSON.stringify({
      ordemAleatoria: prefs.ordemAleatoria === true,
      transparente: prefs.transparente === true,
      formatoFeed: prefs.formatoFeed === true,
      ocultarPontas: prefs.ocultarPontas !== false,
    }));
  } catch { /* storage indisponível — a preferência vale só nesta sessão */ }
}

// Fisher-Yates. Embaralha uma CÓPIA: a ordem canônica (MEAL_CARD_ORDER /
// WORKOUT_CARD_ORDER) é constante exportada e não pode ser mutada.
export function embaralhar(lista) {
  const copia = [...lista];
  for (let i = copia.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [copia[i], copia[j]] = [copia[j], copia[i]];
  }
  return copia;
}
